import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import React from 'react';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Función para resaltar texto en una cadena
export function highlightText(text: string, query: string): React.ReactNode {
  if (!query.trim()) return text;
  
  const parts = text.split(new RegExp(`(${query})`, 'gi'));
  
  return React.createElement(
    React.Fragment,
    null,
    parts.map((part, i) => 
      part.toLowerCase() === query.toLowerCase() 
        ? React.createElement('span', { key: i, className: "bg-yellow-200 dark:bg-yellow-800" }, part)
        : part
    )
  );
} 
